import { useGlobalStore } from "@/store/global-store";
import { TGetProducts } from "@/types/products";
import { TTag } from "@/types/tags";
import { useEffect, useState } from "react";

export type TFormattedProduct = {
	id: string;
	slug: string;
	logo: string | null;
	name: string;
	tagline: string;
	description: string;
	tags: TTag[];
	industriesServed: string[];
	region: string;
	isUpvoted: boolean;
	votesCount: number;
	commentsCount: number;
	companySlug: string;
	hqLocation: string
};

const isProductUpvotedByUser = (userVotes: string[], productId: string) => {
	const isUpvoted = userVotes?.find((vote) => vote === productId);
	return isUpvoted ? true : false;
};

const useFormattedProductsData = (products: TGetProducts) => {
	const { userVotes = [], productVotes = [], productsCommentCount = [] } = useGlobalStore();
	const [formattedProducts, setFormattedProducts] = useState<TFormattedProduct[]>([]);

	useEffect(() => {
		const formattedProducts = products.map((product) => ({
			id: product.id.toString(),
			slug: product.slug,
			logo: product.logo,
			name: product.name,
			tagline: product.tagline,
			description: product.description,
			tags: product.tags,
			industriesServed: product.industriesServed,
			region: product.regions[0]?.region?.name || "",
			isUpvoted: isProductUpvotedByUser(userVotes, product.id),
			votesCount: product.votesCount || 0,
			commentsCount: product.commentsCount || 0,
			companySlug: product.companySlug,
			hqLocation: product.hqLocation
		}));

		setFormattedProducts(formattedProducts);
	}, [products, userVotes, productVotes, productsCommentCount]);

	return formattedProducts;
};

export default useFormattedProductsData;
